import { render, staticRenderFns } from "./temhead3.vue?vue&type=template&id=4f2c559a&scoped=true"
import script from "./temhead3.vue?vue&type=script&lang=js"
export * from "./temhead3.vue?vue&type=script&lang=js"
import style0 from "./temhead3.vue?vue&type=style&index=0&id=4f2c559a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2c559a",
  null
  
)

export default component.exports